<template>
    <span>Bienvenue sur le tableau de bord !!!</span>
</template>
<script>
  export default {
    name: 'notification-sample'
  }
</script>
<style>
</style>
